/**
 * Géométrie de la planche d'étiquettes — SOURCE DE VÉRITÉ UNIQUE.
 *
 * Ces valeurs sont partagées par l'aperçu écran (A4Preview) et par le
 * générateur PDF (pdfGenerator). Ne jamais dupliquer ces constantes ailleurs :
 * un aperçu qui dérive du PDF d'un demi-millimètre est invisible à l'écran mais
 * décale toute la planche à l'impression.
 *
 * Format cible : planche A4 de 24 étiquettes 63,5 × 33,9 mm, 3 colonnes × 8
 * rangées (équivalent Avery L7159 / Herma 4459 / Apli 01285).
 */

export const PAGE_WIDTH_MM = 210;
export const PAGE_HEIGHT_MM = 297;

export const COLS = 3;
export const ROWS = 8;
export const LABELS_PER_PAGE = COLS * ROWS; // 24

export const MARGIN_LEFT_MM = 6;
export const MARGIN_TOP_MM = 9;
export const LABEL_WIDTH_MM = 63.5;
export const LABEL_HEIGHT_MM = 33.875;
export const GAP_H_MM = 3;
export const GAP_V_MM = 1;

/** Coin supérieur gauche de l'étiquette `index` (0 → 23), en millimètres. */
export function labelOrigin(index) {
  const col = index % COLS;
  const row = Math.floor(index / COLS);
  return {
    x: MARGIN_LEFT_MM + col * (LABEL_WIDTH_MM + GAP_H_MM),
    y: MARGIN_TOP_MM + row * (LABEL_HEIGHT_MM + GAP_V_MM),
  };
}

/**
 * Les mêmes mesures exprimées en pourcentages de la page, pour que l'aperçu
 * CSS soit millimétriquement fidèle au PDF.
 */
export const previewMetrics = {
  paddingTop: `${(MARGIN_TOP_MM / PAGE_HEIGHT_MM) * 100}%`,
  paddingLeft: `${(MARGIN_LEFT_MM / PAGE_WIDTH_MM) * 100}%`,
  gridWidth: `${((COLS * LABEL_WIDTH_MM + (COLS - 1) * GAP_H_MM) / PAGE_WIDTH_MM) * 100}%`,
  gridHeight: `${((ROWS * LABEL_HEIGHT_MM + (ROWS - 1) * GAP_V_MM) / PAGE_HEIGHT_MM) * 100}%`,
  columnGap: `${(GAP_H_MM / PAGE_WIDTH_MM) * 100}%`,
  rowGap: `${(GAP_V_MM / PAGE_HEIGHT_MM) * 100}%`,
  aspectRatio: `${PAGE_WIDTH_MM} / ${PAGE_HEIGHT_MM}`,
};
